<template>
  <div class="common-bg pay-cashier-page">
    <van-nav-bar title="在线支付" left-arrow @click-left="onBack" class="cashier-nav-bar" />

    <!-- 首次进入：自动跳转到网关收银台（网关禁止iframe内嵌，只能整页跳转） -->
    <div v-if="stage === 'jumping'" class="cashier-tip-wrap">
      <van-loading size="0.6rem" color="#DFB372" vertical>正在跳转支付页面...</van-loading>
      <div class="cashier-tip-sub">如未自动跳转，请点击下方按钮</div>
      <div class="cashier-actions">
        <van-button round class="cashier-btn-gold" @click="goPay">前往支付</van-button>
      </div>
    </div>

    <!-- 从支付页返回：等待/确认支付结果 -->
    <div v-else class="cashier-tip-wrap">
      <div class="cashier-clock-icon"><van-icon name="clock" /></div>
      <div class="cashier-tip-title">支付完成了吗？</div>
      <div class="cashier-tip-sub">完成支付后，系统将自动确认到账<br />也可点击下方按钮立即查询</div>
      <div class="cashier-actions">
        <van-button round class="cashier-btn-gold" :loading="querying" @click="queryOnce">我已完成支付，查询到账</van-button>
        <van-button round plain class="cashier-btn-plain" @click="goPay">重新打开支付页</van-button>
        <van-button round plain class="cashier-btn-plain" @click="onBack">返回首页</van-button>
      </div>
      <div class="cashier-order-no">订单号：{{ orderNo }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'payCashier',
  data() {
    return {
      orderNo: '',
      payUrl: '',
      // jumping=首次进入准备跳转；waiting=从支付页返回等待结果
      stage: 'jumping',
      pollTimer: null,
      pollCount: 0,
      finished: false,
      querying: false,
      redirectTimer: null,
    };
  },
  created() {
    this.orderNo = sessionStorage.getItem('gateway_pending_order') || '';
    this.payUrl = sessionStorage.getItem('gateway_pay_url') || '';
    if (!this.orderNo || !this.payUrl) {
      this.$toast('支付订单信息已失效，请重新下单');
      this.$router.replace('/');
      return;
    }
    // 已跳转过说明用户是从支付页点浏览器返回，停在等待页，不再自动跳
    if (sessionStorage.getItem('gateway_jumped') === '1') {
      this.stage = 'waiting';
    }
  },
  mounted() {
    // bfcache 返回时（页面不重新created）也切到等待页
    window.addEventListener('pageshow', this.onPageShow);
    if (this.stage === 'waiting') {
      this.startPolling();
    } else {
      // 短暂展示跳转提示后自动跳走
      this.redirectTimer = setTimeout(() => {
        this.goPay();
      }, 800);
    }
  },
  methods: {
    onPageShow(e) {
      if (e.persisted && this.stage === 'jumping') {
        this.clearRedirect();
        this.stage = 'waiting';
        this.startPolling();
      }
    },
    clearRedirect() {
      if (this.redirectTimer) {
        clearTimeout(this.redirectTimer);
        this.redirectTimer = null;
      }
    },
    // 整页跳转到网关收银台（保留浏览历史，用户可点浏览器返回回到本页）
    goPay() {
      if (!this.payUrl) return;
      sessionStorage.setItem('gateway_jumped', '1');
      window.location.href = this.payUrl;
    },
    // 左上角返回：回首页（订单仍保留，可在存款记录查看）
    onBack() {
      this.$router.replace('/');
    },
    startPolling() {
      this.stopPolling();
      this.pollCount = 0;
      this.pollTimer = setInterval(() => {
        this.pollCount++;
        if (this.pollCount > 40) {
          // 最多轮询2分钟，停止但保留页面
          this.stopPolling();
          return;
        }
        this.doQuery(false);
      }, 3000);
    },
    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },
    // 手动立即查询
    queryOnce() {
      this.querying = true;
      this.doQuery(true);
    },
    doQuery(manual) {
      this.$apiFun.post('/api/gatewayPay/query', { out_trade_no: this.orderNo }).then(res => {
        this.querying = false;
        if (res.code == 200 && res.data) {
          if (Number(res.data.state) === 2) {
            this.onPaySuccess();
          } else if (Number(res.data.state) === 3) {
            this.stopPolling();
            this.$toast('支付失败，如已扣款请联系客服');
          } else if (manual) {
            this.$toast('暂未查到支付结果，请完成支付后稍候再试');
          }
        } else if (manual) {
          this.$toast('查询失败，请稍后再试');
        }
      }).catch(() => {
        this.querying = false;
      });
    },
    onPaySuccess() {
      if (this.finished) return;
      this.finished = true;
      this.stopPolling();
      try {
        sessionStorage.removeItem('gateway_pay_url');
        sessionStorage.removeItem('gateway_jumped');
      } catch (e) {}
      this.$toast.success('存款成功，金额已到账');
      // 复用首页 ?payback= 回跳逻辑：自动打开存款记录（hash 路由需带 /#/）
      setTimeout(() => {
        window.top.location.replace('/#/?payback=' + encodeURIComponent(this.orderNo));
      }, 800);
    },
  },
  beforeDestroy() {
    this.clearRedirect();
    this.stopPolling();
    window.removeEventListener('pageshow', this.onPageShow);
  },
};
</script>

<style lang="scss" scoped>
@import '../../static/css/common.css';

.pay-cashier-page {
  min-height: 100vh;
  background-color: #1e1f24;
  display: flex;
  flex-direction: column;
}

.cashier-tip-wrap {
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 1.2rem 0.6rem;
  box-sizing: border-box;
}

.cashier-clock-icon {
  font-size: 1.1rem;
  color: #DFB372;
  margin-bottom: 0.4rem;
}

.cashier-tip-title {
  font-size: 0.4rem;
  color: #fff;
  font-weight: bold;
  margin-bottom: 0.3rem;
}

.cashier-tip-sub {
  font-size: 0.26rem;
  color: #999;
  line-height: 0.45rem;
  text-align: center;
  margin-bottom: 0.6rem;
}

.cashier-actions {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.cashier-actions .van-button {
  width: 80%;
  margin-bottom: 0.3rem;
  font-size: 0.3rem;
}

.cashier-btn-gold.van-button {
  background: #DFB372;
  border-color: #DFB372;
  color: #1e1f24;
  font-weight: bold;
}

.cashier-btn-plain.van-button {
  background: transparent;
  border: 1px solid #555;
  color: #ccc;
}

.cashier-order-no {
  margin-top: 0.4rem;
  font-size: 0.22rem;
  color: #666;
  text-align: center;
  word-break: break-all;
}
</style>

<style lang="scss">
.cashier-nav-bar.van-nav-bar,
.van-nav-bar.cashier-nav-bar {
  background-color: #1e1f24 !important;
}
.cashier-nav-bar.van-nav-bar .van-nav-bar__title,
.van-nav-bar.cashier-nav-bar .van-nav-bar__title {
  color: #fff !important;
  font-size: 0.36rem !important;
}
.cashier-nav-bar.van-nav-bar .van-icon,
.van-nav-bar.cashier-nav-bar .van-icon,
.cashier-nav-bar.van-nav-bar .van-nav-bar__arrow,
.van-nav-bar.cashier-nav-bar .van-nav-bar__arrow {
  color: #fff !important;
}
.cashier-nav-bar.van-hairline--bottom:after,
.van-nav-bar.cashier-nav-bar.van-hairline--bottom:after {
  border-bottom-width: 0 !important;
  border: none !important;
  height: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/payCashier.vue